<template>
    <div class="card-frame">
        <div class="card-station">
            <!-- <img src="../assets/Rectangle 190.png" alt=""> -->
            <img :src="imgStation" alt="" class="station-img">
            <div style="  display: flex; flex-direction: column; gap: 4px;">
                <div class="card-title">
                    <!-- Jowit Rachayothin Station -->
                    <!-- {{ station[markerIndex].name }} -->
                    {{ station.name }}
                </div>
                <div class="card-text">
                    <!-- Phahonyothin Road, Khwaeng Lat Yao, Khet Chatuchak, Bangkok -->
                    <!-- {{ station[markerIndex].sub_district }},
                    {{ station[markerIndex].district }},
                    {{ station[markerIndex].province }} -->
                    {{ station.sub_district }}
                    {{ station.district }}
                    {{ station.province }}

                </div>
                <div style="display: flex; margin: 8px 0 20px ;">
                    <div class="slot-battery">
                        <!-- <Icon icon="maki:charging-station" class="icon-station" />{{ station[markerIndex].slot }} packs -->
                        <Icon icon="maki:charging-station" class="icon-station" />{{ station.slot }} packs
                    </div>
                    <div class="distance">
                        <Icon icon="ion:navigate" class="icon-station" />1.25 km
                    </div>
                </div>
            </div>
            <!-- <Button class="start-btn" @click="navigateToMarker()">Start</Button> -->

            <span @click="navigateToMarker()"> <Button class="start-btn">Start</Button></span>
        </div>
    </div>
</template>

<script>
import Button from './Button.vue';
import { Icon } from '@iconify/vue2'

export default {
    name: "CardStation",
    props: ['station'],
    components: {
        Button,
        Icon
    },
    methods: {
        navigateToMarker() {
            const selectedMarker = this.station;
            const lat = selectedMarker.lat;
            const lng = selectedMarker.lng;
            window.open(`https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`);
        },
    },
    data() {
        return {
            imgStation: '',
        }
    },
    updated() {
        this.imgStation = this.station.imge
    },
}
</script>

<style scoped lang="scss">
.card-frame {
    padding: 0 20px 0 20px;
}

.card-station {
    position: relative;
    display: flex;
    background: #fff;
    flex-direction: column;
    padding: 16px;
    border-radius: 16px;
    box-shadow: 2px 2px 15px 0px rgba(0, 0, 0, 0.05);
    z-index: 10;
}

.card-title {
    font-size: var(-font-bigger);
    font-weight: 600;
    color: var(--theme-one);
    margin-top: 16px;
}

.card-text {
    font-size: 10px;
    color: #686868;
}



.start-btn {
    color: #fff;
    font-size: var(-font-bigger);
    min-width: 100% !important;
    min-height: 38px;
    border-radius: 8px;
    /* margin-top: 20px; */
}

.slot-battery,
.distance {
    display: flex;
    align-items: center;
    justify-items: center;
    padding: 6px 8px;
    border: 1px solid #FFEFD6;
    border-radius: 24px;
    font-size: 10px;
    margin-right: 8px;
}

.icon-station {
    padding-block: 2px;
    color: var(--theme-one);
    background: #FFEFD6;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    margin-right: 4px;
}

.station-img {
    height: 140px;
    object-fit: cover;
    object-position: center;
    border-radius: 8px;
}
</style>